import moment from 'moment';
import { isNil } from 'ramda';

import CurrencyPresenter from '../presenters/CurrencyPresenter';

export function formatDate(date) {
  return moment(date).format('MM-DD-YYYY h:mm a');
}

export function findById(collection, id) {
  return collection.find((item) => item.id === id);
}

export const amountReadable = (amount) => {
  if (isNil(amount)) return '--';

  return CurrencyPresenter.formatDollarAmount(amount);
};
